import type { IBrand } from "../../../../types/models/brands.models.types";
import type { IzCreateBrandFormAdmin } from "../../../../types/models/create-brand-form.types";
import { usePostHttp } from "../../http.hook";

interface IResponse extends Array<IBrand> {}

export function useCreateBrandAdminHttp() {
  return usePostHttp<IzCreateBrandFormAdmin, IResponse>({
    path: "/admin/brands",
  });
}
